import type { CSSInterpolation } from '@emotion/serialize';

import type { Styling } from 'src/context/styling';
import { flex, styleInvalidSubmitButton } from 'src/styling/constants';
import mq from 'src/styling/media-queries';

export const spacerForUnderFooter = {
  ':after': {
    content: '""',
    display: 'block',
    height: '7rem',
  },
};

export const maxWidth = '27.625rem';

const inputNoBottomBorderStyle: CSSInterpolation = { input: { borderBottomStyle: 'none' } };

export const fieldWrapperStyle = (styling: Styling, hideBottomBorder = false): CSSInterpolation =>
  mq([
    flex.column,
    styling.fonts.light,
    {
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'flex-start',
    },
    ...(hideBottomBorder ? [inputNoBottomBorderStyle] : []),
  ]);

const journeyButtonPadding: CSSInterpolation = { padding: '0.8rem 1rem' };

export const formInnerWrapperStyling = mq.withSmallTablet({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  margin: '0 auto',
  maxWidth,
  fontSize: '1rem',
  alignItems: 'center',
  justifyContent: 'center',
});

export const formPadding: CSSInterpolation = mq.withSmallTablet({
  padding: ['0 1rem', '0 4rem', '0 4rem'],
});

export const formWrapperStyling = (styling: Styling) => [
  mq.withSmallTablet({
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1rem',
  }),
  formPadding,
  styleInvalidSubmitButton([styling.buttons.disabled, journeyButtonPadding]),
];

export const h2TitleStyling = (styling: Styling) =>
  mq([
    styling.fonts.bold,
    {
      fontSize: ['2rem', '2.5rem'],
      textAlign: 'center',
      marginTop: ['1.5rem', '2.25rem'],
      marginBottom: ['1rem', '1.5rem'],
      width: '100%',
      color: styling.colors.bodyText,
    },
  ]);

export const h3TitleStyling = (styling: Styling) =>
  mq([
    styling.fonts.bold,
    {
      fontSize: ['1.5rem', '2rem'],
      textAlign: 'center',
      marginTop: ['1rem', '2rem'],
      width: '100%',
      color: styling.colors.bodyText,
    },
  ]);

export const spacer = { marginTop: '1.5rem', marginBottom: '1.5rem' };

export const subtitleStyling = (styling: Styling) =>
  mq([
    styling.fonts.regular,
    {
      textAlign: 'center',
      fontSize: '1rem',
      marginBottom: ['1.5rem', '2.25rem'],
    },
  ]);

export const reminderTextStyling = (styling: Styling) =>
  mq([
    styling.fonts.light,
    {
      fontSize: '1rem',
      textAlign: 'center',
      padding: '0 1rem',
    },
  ]);
